/**
 * Generates the redirect URI for Slack OAuth flow.
 * Uses the current pathname without search params for exact matching.
 */
export const getSlackRedirectUri = (): string => {
  // If you change this URI change it also in slack management interface
  return new URL('/notifications', window.location.origin).toString();
};
